import React from 'react';
import classNames from 'classnames';
import Loading from '../Loading';
import CustomTooltip from '../Tooltip';
import config from '../../config';
import ReportByReferralComponent from "../../utils/ReportByReferralComponent/ReportByReferralComponent";

class ReportByReferral extends React.Component {
    constructor(props, context, { tableWrapperClass = {} } = {}) {
        super();

        this.tableWrapperClass = { 'table-responsive': true, ...tableWrapperClass };
        this.onUpdateSort = this.onUpdateSort.bind(this);
    }

    onUpdateSort(event) {
        let sort = event.target.closest('.report-table__th-sort').getAttribute('data-key');
        let order = this.state.order;

        if (sort === this.state.sort) {
            order = (order === 'desc') ? 'asc' : 'desc';
        } else {
            order = 'desc';
        }

        this.props.onAction({
            sort,
            order,
            page: config.initialPage
        });
    }

    setBodyData() {
        if (this.refs.body) {
            if (this.state.loading) {
                this.refs.body.innerHTML = '';
            } else {
                this.refs.body.innerHTML = this.state.data || '';
            }
        }
    }

    renderHeader() {
        if (!this.state.headerName) return null;

        let groupByTitle = ReportByReferralComponent.utils.getGroupBy();
        return (
            <thead className="bold">
                {this.state.headerName.map((items, i) => {
                    return (
                        <tr key={i}>
                            {items.map((item, j) => {
                                let title = 'GroupBy' === item.config.key ? groupByTitle.title : item.title;
                                return (
                                    item.visible
                                        ? (
                                            <th
                                                className={`report-table__th`}
                                                key={j}
                                                colSpan={item.colspan}
                                                rowSpan={item.rowspan}
                                            >
                                                {item.description
                                                    ? (
                                                        <CustomTooltip id={`header-${i}-${j}`} tooltip={item.description}>
                                                            <span className="report-table__th-text">{title}</span>
                                                        </CustomTooltip>
                                                    )
                                                    : <span className="report-table__th-text">{title}</span>
                                                }
                                                {item.isSortable && this.state.isSorting && this.state.keysMetric.indexOf(item.config.key) !== -1
                                                    ? (
                                                        <span
                                                            className={`report-table__th-sort ${this.state.sort === item.config.key ? 'active': ''}`}
                                                            data-key={item.config.key}
                                                            onClick={this.onUpdateSort}
                                                        >
                                                            <i className={`fa fa-sort-amount-${this.state.order}`} />
                                                        </span>
                                                    )
                                                    : null
                                                }
                                            </th>
                                        )
                                        : null
                                )
                            })}
                        </tr>
                    )
                })}
            </thead>
        );
    }

    render() {
        const staticNamesTable = this.context.t.dataTable;
        const hasTableContent = Boolean(this.state.data && this.state.data.trim());
        const hasRows = typeof this.props.rowsCount === 'number' ? this.props.rowsCount > 0 : false;
        const showLoadingOverlay = this.state.loading && hasTableContent;
        const showLoadingCenter = this.state.loading && !hasTableContent;
        const showEmptyPlaceholder = !this.state.loading && !hasTableContent && !hasRows;

        return (
            <div className="loading-wrapper">
                {showLoadingOverlay && (
                    <div className="loading-wrapper__item">
                        <Loading />
                    </div>
                )}
                <div className={classNames(this.tableWrapperClass)}>
                    <table className={classNames({
                        'table': true,
                        'table-striped': false,
                        'table-bordered': false,
                        'report-table': true,
                        'green-hover': true,
                        'report-table_first': this.state.isTableFirst,
                        'report-table_last': this.state.isTableLast
                    })}>
                        {this.renderHeader()}
                        <tbody ref={'body'} />
                    </table>
                    {showLoadingCenter && <Loading center />}
                    {!showLoadingCenter && showEmptyPlaceholder && (
                        <div className="text-center table-notfound-sign">{staticNamesTable.noData}</div>
                    )}
                </div>
            </div>
        )
    };
}

ReportByReferral.propTypes = {};

ReportByReferral.defaultProps = {};

export default ReportByReferral;
